import { BakhoorSection } from "../components/BakhoorSection";
import { ProductShowcase } from "../components/ProductShowcase";
import { useProductsByCategory } from "../catalog";

export default function BakhoorPage({ onAdd }) {
    const products = useProductsByCategory("bakhoor");
    return (
        <div data-testid="bakhoor-page" className="pt-16 sm:pt-20">
            <BakhoorSection />
            {products.map((p, i) => (
                <ProductShowcase key={p.id} product={p} index={i} reversed={i % 2 === 1} tint={i % 2 === 0 ? "bg-cream" : "bg-ivory"} onAdd={onAdd} />
            ))}
        </div>
    );
}
